module.exports = __webpack_public_path__ + "static/media/19-11.6691b1dd.mp3";